/*import { Header } from "../Header/Header"
const header = new Header()
window.header = header*/

import { Cart } from "../mod_cart/mod_cart.js"
const cart = new Cart()
window.cart = cart

import { Fav } from "../mod_fav/mod_fav.js"
const fav = new Fav()
window.fav = fav

import { Prod } from "../mod_zayav/reg_prod.js"
const prod = new Prod()
window.prod = prod

import { Popup } from "../mod_popups/mod_popups"
const popup = new Popup()
popup.clear = "1" + "3"
window.popup = popup

//тут был слайдер(смотри историю), теперь тут обрезка автовоспроизведения
const videoContainers = document.querySelectorAll(".simple-description__video")

videoContainers.forEach(container => {
	const iframe = container.querySelector("iframe")
	if (iframe) {
		try {
			const url = new URL(iframe.src)
			url.searchParams.delete("autoplay")
			iframe.src = url.toString()
		} catch (e) {
			console.error("Не удалось обработать URL iframe:", e)
		}
	}
})

// Ввод
const cyrillicRegex = /^[а-яА-ЯёЁ]+$/

document.addEventListener("DOMContentLoaded", function() {
	const fields = document.querySelectorAll(
		"input[name='str_lastname'], input[name='str_firstname'], input[name='str_secondname']"
	)

	fields.forEach(function(field) {
		field.addEventListener("input", function() {
			if (!cyrillicRegex.test(field.value)) {
				field.classList.add("error")
				const errorMessage = field.parentNode.querySelector(".error-message")
				errorMessage.style.display = "block"
				errorMessage.style.color = "red"
				field.style.borderColor = "red"
			} else {
				field.classList.remove("error")
				const errorMessage = field.parentNode.querySelector(".error-message")
				errorMessage.style.display = "none"
				field.style.borderColor = ""
			}
		})
	})

	fields.forEach(function(field) {
		const errorMessage = document.createElement("div")
		errorMessage.className = "error-message"
		errorMessage.textContent = "Только кириллица"
		field.parentNode.appendChild(errorMessage)
		errorMessage.style.display = "none"
	})
})
function addPhoneCodes() {
	var countries = {
		Россия: "+7",
		Армения: "+374",
		Азербайджан: "+994",
		Беларусь: "+375",
		Грузия: "+995",
		Казахстан: "+77",
		Кыргыстан: "+996",
		Латвия: "+371",
		Литва: "+370",
		Молдова: "+373",
		Таджикистан: "+992",
		Туркменистан: "+993",
		Украина: "+380",
		Узбекистан: "+998",
		Эстония: "+372",
		Афганистан: "+93",
		Албания: "+355",
		Алжир: "+21",
		"Американское Самоа": "+684",
		Андорра: "+376",
		Ангола: "+244",
		Аргентина: "+54",
		Австралия: "+61",
		Австрия: "+43",
		Бахрейн: "+973",
		Бангладеш: "+880",
		Бельгия: "+32",
		Белиз: "+501",
		Бенин: "+229",
		Боливия: "+591",
		"Босния и Герцеговина": "+387",
		Ботсвана: "+267",
		Бразилия: "+55",
		"Бруней Даруэсалаам": "+673",
		Болгария: "+359",
		"Буркина Фасо": "+226",
		Бурунди: "+257",
		Камбоджа: "+855",
		Камерун: "+237",
		Канада: "+1",
		"Капе верде": "+238",
		ЦАР: "+236",
		Чад: "+235",
		Чили: "+56",
		Китай: "+86",
		"Рождественсткие острова": "+672",
		"Кокосовые острова": "+672",
		Колумбия: "+57",
		"Коморские острова": "+269",
		Конго: "+242",
		"Острова Кука": "+682",
		"Коста-Рика": "+506",
		Хорватия: "+385",
		Куба: "+53",
		Кипр: "+357",
		"Чешская республика": "+420",
		Дания: "+45",
		Джибути: "+253",
		"Восточный Тимор": "+62",
		Эквадор: "+593",
		Египет: "+20",
		Сальвадор: "+503",
		"Экваториальная Гвинея": "+240",
		Эфиопия: "+251",
		"Фолклендские острова": "+500",
		Фиджи: "+679",
		Финляндия: "+358",
		Франция: "+33",
		"Французские Антиллы": "+590",
		"Французская Гвиана": "+594",
		"Франзузская полинезия": "+689",
		Габон: "+241",
		Гамбия: "+220",
		Германия: "+49",
		Гана: "+233",
		Гибралтар: "+350",
		Греция: "+30",
		Гренландия: "+299",
		Гватемала: "+502",
		Гвинея: "+224",
		"Гвинея Биссау": "+245",
		Гайана: "+592",
		Гаити: "+509",
		Гондурас: "+504",
		"Гон-Конг": "+852",
		Венгрия: "+36",
		исландия: "+354",
		Индия: "+91",
		Индонезия: "+62",
		Иран: "+98",
		Ирак: "+964",
		"Ирландская республика": "+353",
		Израиль: "+972",
		Италия: "+39",
		"Берег слоновой кости": "+225",
		Япония: "+81",
		Иордания: "+962",
		Кения: "+254",
		Кирибати: "+686",
		Кыргызстан: "+996",
		Кувейт: "+965",
		Лаос: "+856",
		Ливан: "+961",
		Лессото: "+266",
		Либерия: "+231",
		Ливия: "+21",
		Лихтенштейн: "+41",
		Люксембург: "+352",
		Макао: "+853",
		Македония: "+389",
		Мадагаскар: "+261",
		Малави: "+265",
		Малайзия: "+60",
		Мальдивы: "+960",
		Мали: "+223",
		Мальта: "+356",
		"Маршалловы острова": "+692",
		Мартиника: "+596",
		Мавритания: "+222",
		Маврикий: "+230",
		Мексика: "+52",
		Микронезия: "+691",
		Монако: "+377",
		Монголия: "+976",
		Мороко: "+212",
		Мозамбик: "+258",
		Намибия: "+264",
		Науру: "+674",
		Непал: "+977",
		Нидерланды: "+31",
		"Нидерландские антиллы": "+599",
		"Новая каледония": "+687",
		"Новая зеландия": "+64",
		Никарагуа: "+505",
		Нигер: "+227",
		Нигерия: "+234",
		"Норфолкские острова": "+672",
		"Северная Корея": "+850",
		"Северный Йемен": "+967",
		"Северно Марианские острова": "+670",
		Норвегия: "+47",
		Оман: "+968",
		Пакистан: "+92",
		Панама: "+507",
		"Папуа Новая Гвинея": "+675",
		Парагвай: "+595",
		Перу: "+51",
		Филипины: "+63",
		Польша: "+48",
		Португалия: "+351",
		Катар: "+974",
		"Республика Сан Марино": "+378",
		Реоньон: "+262",
		Румыния: "+40",
		"Республика Руанда": "+250",
		"Сан Марино": "+39",
		"Саудовская Аравия": "+966",
		Сенегал: "+221",
		"Сьерра Леоне": "+232",
		Сингапур: "+65",
		Словакия: "+421",
		Словения: "+386",
		"Соломоновы острова": "+677",
		Сомали: "+252",
		ЮАР: "+27",
		"Южная Корея": "+82",
		"Южный Йемен": "+969",
		Испания: "+34",
		"Шри Ланка": "+94",
		Судан: "+249",
		Суринам: "+597",
		Свазиленд: "+268",
		Швеция: "+46",
		Швейцария: "+41",
		Сирия: "+963",
		Тайвань: "+886",
		Танзания: "+255",
		Тайланд: "+66",
		"Республика Тоголезе": "+228",
		Тонго: "+676",
		Тунис: "+21",
		Турция: "+90",
		Уганда: "+256",
		"О.А.Э.": "+971",
		Великобритания: "+44",
		Уругвай: "+598",
		США: "+1",
		Ватикан: "+39",
		Венесуэла: "+58",
		Вьетнам: "+84",
		"Западная Сахара": "+21",
		"Западное Самоа": "+685",
		Югославия: "+381",
		Заир: "+243",
		Замбия: "+260",
		Зимбабве: "+263",
	}

	let phone = $("input.form__tel-input").val()

	phone = phone.split(" ").join("")
	phone = phone.split("(").join("")
	phone = phone.split(")").join("")
	phone = phone.split("-").join("")

	$("input.form__tel-input").val(phone)

	$.each(countries, function(index, element) {
		let code = phone.substr(0, element.length)
		if (element == code) {
			$(".form__tel-select").prepend(
				'<option value="' +
					element +
					'" selected="selected">' +
					element +
					"(" +
					index +
					")</option>"
			)
		} else {
			$(".form__tel-select").append(
				'<option value="' +
					element +
					'">' +
					element +
					"(" +
					index +
					")</option>"
			)
		}
	})
}

//-----------------------------------------
// Валидация количества цифр в телефоне

$("input.form__tel-input").on("input", function() {
	let parent = $(this)
	let input = $(parent)
		.parent()
		.find("input.form__tel-input")

	let str = $(input).val()

	if (str[0] === "+") {
		str = str.slice(1)
	}

	str = str.split(" ").join("")
	str = str.split("(").join("")
	str = str.split(")").join("")
	str = str.split("-").join("")
	let len = str.length

	if (len != 11) {
		this.setCustomValidity(
			"Количество введенных вами цифр: " +
				len +
				". Номер телефона не соответствует стандарту (11-значный номер)!"
		)
	} else {
		this.setCustomValidity("")
	}
})

// is touch
function isTouchDevice() {
	return (
		"ontouchstart" in window ||
		navigator.maxTouchPoints > 0 ||
		navigator.msMaxTouchPoints > 0
	)
}

if (isTouchDevice()) {
	$("body").removeClass("des")
	$("body").addClass("mob")
} else {
	$("body").removeClass("mob")
	$("body").addClass("des")
}

// resize
$(window).resize(function() {
	// is touch
	isTouchDevice()
})

$(".slider__list").slick({
	dots: true,
	dotsClass: "slider-dots",
	infinite: false,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 10000,
	adaptiveHeight: true,
})

$(".catalog__slider").slick({
	dots: false,
	nextArrow:
		'<button type="button" class="slider__arrow slider__arrow-right" aria-label="Previous"></button>',
	prevArrow:
		'<button type="button" class="slider__arrow slider__arrow-left" aria-label="Next"></button>',
	infinite: false,
	speed: 300,
	slidesToShow: 4,
	slidesToScroll: 4,
	variableWidth: true,
	responsive: [
		{
			breakpoint: 1380,
			settings: {
				dots: false,
				nextArrow:
					'<button type="button" class="slider__arrow slider__arrow-right" aria-label="Previous"></button>',
				prevArrow:
					'<button type="button" class="slider__arrow slider__arrow-left" aria-label="Next"></button>',
				infinite: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 3,
				variableWidth: true,
			},
		},
		{
			breakpoint: 1024,
			settings: {
				dots: false,
				arrows: false,
				infinite: false,
				speed: 300,
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: true,
				variableWidth: true,
			},
		},
	],
})

$(".method-slider__list").slick({
	dots: true,
	dotsClass: "slider-dots",
	nextArrow:
		'<button type="button" class="method-slider__arrow method-slider__arrow-right" aria-label="Previous"></button>',
	prevArrow:
		'<button type="button" class="method-slider__arrow method-slider__arrow-left" aria-label="Next"></button>',
	infinite: false,
	speed: 300,
	centerMode: true,
	variableWidth: true,
})

$(".method-screens__list").slick({
	dots: true,
	dotsClass: "slider-dots",
	nextArrow:
		'<button type="button" class="method-screens__arrow method-screens__arrow-right" aria-label="Previous"></button>',
	prevArrow:
		'<button type="button" class="method-screens__arrow method-screens__arrow-left" aria-label="Next"></button>',
	infinite: false,
	speed: 300,
	slidesToShow: 4,
	slidesToScroll: 1,
	responsive: [
		{
			breakpoint: 1380,
			settings: {
				slidesToShow: 3,
			},
		},
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				variableWidth: true,
				centerMode: true,
			},
		},
	],
})

$(".method-reviews__list").slick({
	dots: false,
	infinite: true,
	nextArrow:
		'<button type="button" class="reviews-slider__arrow reviews-slider__arrow-right" aria-label="Previous"></button>',
	prevArrow:
		'<button type="button" class="reviews-slider__arrow reviews-slider__arrow-left" aria-label="Next"></button>',
	speed: 300,
	adaptiveHeight: true,
})

$(".simple-main__photos-big").slick({
	asNavFor: ".simple-main__photos-mini",
	arrows: false,
	dots: true,
	dotsClass: "slider-dots",
})

$(".simple-main__photos-mini").slick({
	asNavFor: ".simple-main__photos-big",
	focusOnSelect: true,
	infinite: true,
	speed: 300,
	nextArrow:
		'<button type="button" class="product-slider__arrow product-slider__arrow-right" aria-label="Previous"></button>',
	prevArrow:
		'<button type="button" class="product-slider__arrow product-slider__arrow-left" aria-label="Next"></button>',
	slidesToShow: 3,
	slidesToScroll: 1,
	variableWidth: true,
	responsive: [
		{
			breakpoint: 1024,
			settings: "unslick",
		},
	],
})

$(".catalog__slider").each(function() {
	let sl = $(this)
	let mh = 0
	sl.find(".catalog__item").each(function() {
		var h_block = parseInt($(this).height())
		if (h_block > mh) {
			mh = h_block
		}
	})
	sl.find(".catalog__item").height(mh)
})

var sliderMoved = false

$(window).scroll(function() {
	if (
		$(this).scrollTop() >=
		$(".header-main").outerHeight() - $(".header-menu").outerHeight()
	) {
		$(".header-menu.fixed").css("top", $(".header-panel").outerHeight())
		$(".header-main").addClass("fixed-bot")
		$(".header-menu").addClass("fixed")
	} else if (
		$(this).scrollTop() <
		$(".header-main").outerHeight() - $(".header-menu").outerHeight()
	) {
		$(".header-main").removeClass("fixed-bot")
		$(".header-menu").removeClass("fixed")
	}

	let v = $(window).height()
	let s = $(window).scrollTop()

	if ($(".company-prestige").length) {
		let h = $(".company-prestige").height()

		let begin = $(".company-prestige").offset().top + h - v
		let end = $(".company-prestige").offset().top

		if (s > begin && s < end) {
			var o = ((s - begin) / (end - begin)) * 100 + "%"
		}
		//console.log(v + ' ' + p + ' ' + h + ' ' + s + ' ' + o);

		$(".company-prestige").css("background-position-y", o)
	}

	if ($(".method-slider").length) {
		let v = $(window).height()
		let s = $(window).scrollTop()
		if (
			s > $(".method-slider").offset().top + $(".method-slider").height() - v &&
			!sliderMoved
		) {
			$(".method-slider__list").slick("slickNext")
			sliderMoved = true
		}
	}
})

$(window).scroll(function() {
	if ($(".promo").length) {
		let v = $(window).height()
		let h = $(".promo__image").height()

		let begin = $(".promo").offset().top + h - v
		let end = $(".promo").offset().top

		let s = $(window).scrollTop()

		if (s > begin && s < end) {
			var o = ((s - begin) / (end - begin)) * 100 + "%"
		}
		//console.log(v + ' ' + p + ' ' + h + ' ' + s + ' ' + o);

		$(".promo__image").css("background-position-y", o)

		if (
			s > $(".slider").offset().top + $(".slider").height() - v &&
			!sliderMoved
		) {
			$(".slider__list").slick("slickNext")
			sliderMoved = true
		}
	}
})

$(".toggle-hamburger").click(function() {
	$(".mobile-menu").addClass("active")
	$("body").addClass("no-scroll")
})

$(".mobile-menu__close").click(function() {
	$(".mobile-menu").removeClass("active")
	$("body").removeClass("no-scroll")
})

$(".catalog-page__open-filter").click(function() {
	$(".filter").addClass("active")
	$("body").addClass("no-scroll")
})

$(".filter__close").click(function() {
	$(".filter").removeClass("active")
	$("body").removeClass("no-scroll")
})

$(".catalog-page__categories-btn").click(function() {
	$(this).toggleClass("active")
	$(".catalog-page__categories").slideToggle(300)
})

$(".filter-form__theme-title").click(function() {
	$(this).toggleClass("active")
	$(this)
		.siblings(".filter-form__theme-block")
		.slideToggle()
})

$(".categories__item-btn").click(function(e) {
	$(this).toggleClass("active")
	$(".categories__item-btn")
		.not(this)
		.removeClass("active")
	$(".categories__item--popup .categories__sub-list").slideToggle("fast")
})

$(".mobile-menu__link--section").on("click", function(e) {
	if ($(this).siblings(".mobile-menu__sublist").length) {
		e.preventDefault()
		$(this)
			.next(".mobile-menu__sublist")
			.slideToggle("fast")
	}
})

$(
	".mobile-menu__link--reg, .header-panel__authorization-link.popup-auth"
).click(function(e) {
	e.preventDefault()
	$(".popup-login").fadeIn(200)
})

$(".popup-login__close").click(function() {
	$(".popup-login").fadeOut(200)
})

$(".popup-login__forget-pass").click(function(e) {
	e.preventDefault()
	$(".popup-typical--forget").fadeIn()
	$("body").addClass("no-scroll")
})

$(document).mouseup(function(e) {
	var callbackPopup = $(".popup-login")
	var modal = $(".swal-modal")
	if (
		!callbackPopup.is(e.target) &&
		callbackPopup.has(e.target).length === 0 &&
		!modal.is(e.target) &&
		modal.has(e.target).length === 0
	) {
		callbackPopup.fadeOut(200)
	}
})

$(".catalog__item-basket").click(function() {
	let item = $(this).closest(".catalog__item")

	let id = $(this).attr("data-id")
	let link = item.find(".catalog__item-link").attr("href")
	let name = item.find(".catalog__item-title").text()
	let price = item.find(".catalog__item-price-main").text()
	let img = item.find(".catalog__item-image").attr("src")

	cart.add2cart(id, 1)
	$(".popup-typical--cart .cart-item__title").text(name)
	$(".popup-typical--cart .cart-item__title").attr("href", link)
	$(".popup-typical--cart .cart-item__price").text("Цена: " + price)
	$(".popup-typical--cart .cart-item__code").text("Арт: " + id)
	$(".popup-typical--cart .cart-item__image img").attr("src", img)
	$(".popup-typical--cart .cart-item-id").val(id)

	$(".popup-typical--cart").fadeIn(300)
	$("body").addClass("no-scroll")
})

$(".method-main__cart-btn").click(function() {
	let item = $(".simple-main__wrapper")

	let id = $(this).attr("data-id")
	let link = location.href
	let name = item.find(".simple-main__title").text()
	let price = item.find(".method-main__price b").text()
	let count = item.find(".method-main__counter input").val()
	let img = item.find(".simple-main__photos-big img").attr("src")

	if (!$(this).is(".method-main__cart-btn--inform")) {
		cart.add2cart(id, count)
		$(".popup-typical--cart .cart-item__title").text(name)
		$(".popup-typical--cart .cart-item__title").attr("href", link)
		$(".popup-typical--cart .cart-item__price").text("Цена: " + price)
		$(".popup-typical--cart .cart-item__code").text("Арт: " + id)
		$(".popup-typical--cart .cart-item__image img").attr("src", img)
		$(".popup-typical--cart .cart-item-id").val(id)

		$(".popup-typical--cart").fadeIn(300)
	} else {
		$(".popup-typical--inform .cart-item__title").text(name)
		$(".popup-typical--inform .cart-item__title").attr("href", link)
		$(".popup-typical--inform .cart-item__code").text("Арт: " + id)
		$(".popup-typical--inform .cart-item__image img").attr("src", img)
		$(".popup-typical--inform .cart-item-id").val(id)

		$(".popup-typical--inform").fadeIn(300)
	}

	$("body").addClass("no-scroll")
})

$(".cart-item__delete-btn").click(function() {
	let item = $(this).closest(".cart-item")
	let id = item.attr("data-id")
	cart.remove(id)
	item.remove()
})

$(".popup-typical__close, .popup-typical__btn--back").click(function() {
	$(this)
		.parents(".popup-typical")
		.fadeOut(300)
	$("body").removeClass("no-scroll")
})

$(document).mouseup(function(e) {
	var callbackPopup = $(".popup-typical__container")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		//$(".popup-typical--callback").fadeOut(300)
		$(".popup-typical--cart").fadeOut(300)
		$(".popup-typical--inform").fadeOut(300)
		$(".popup-typical--forget").fadeOut(300)
		$("body").removeClass("no-scroll")
	}
})

$(".popup-text__open").click(function(e) {
	e.preventDefault()

	if (
		$(this)
			.attr("href")
			.match(/#.+/)
	) {
		let b = $(this)
			.attr("href")
			.replace(/#/, "")
		$(".popup-text__main").html(
			$(".popup-content div[data-block=" + b + "]").html()
		)
		$(".popup-text__title").html(
			$(".popup-content div[data-block=" + b + "] h2").html()
		)
	}

	$(".popup-text").fadeIn(300)
	$("body").addClass("no-scroll")
})

$(".popup-text__close, .popup-text__btn-close").click(function() {
	$(".popup-text").fadeOut(300)
	$("body").removeClass("no-scroll")
})

$(document).mouseup(function(e) {
	var callbackPopup = $(".popup-text__container")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(".popup-text").fadeOut(300)
		$("body").removeClass("no-scroll")
	}
})

$(".filter-select__selection-list .filter-select__selection-input").change(
	function() {
		let el = $(this)
		let id = el.val()
		let p = el.closest(".filter-select")
		let r = p.find(".filter-select__results-list")
		let v = el.next().text()
		if (el.prop("checked")) {
			r.append(
				'<li class="filter-select__results-item">' +
					'<button class="filter-select__results-item-delete" type="button" data-id="' +
					id +
					'">' +
					'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.002 15">' +
					'<path fill="#b7aca1" id="Path_47" d="M7.5 0A7.5 7.5 0 1 0 15 7.5 7.427 7.427 0 0 0 7.5 0zm3.8 9.7a1.217 1.217 0 0 1 0 1.6 1.217 1.217 0 0 1-1.6 0L7.5 9.2l-2.2 2.2a1.217 1.217 0 0 1-1.6 0 1.217 1.217 0 0 1 0-1.6l2.2-2.2-2.1-2.2a1.217 1.217 0 0 1 0-1.6 1.217 1.217 0 0 1 1.6 0L7.6 6l2.2-2.2a1.217 1.217 0 0 1 1.6 0 1.217 1.217 0 0 1 0 1.6L9.2 7.5z" data-name="Path 47" /> ' +
					"</svg>" +
					"<span>" +
					v +
					"</span>" +
					"</button>" +
					"</li>"
			)
		} else {
			p.find(
				'.filter-select__results-list .filter-select__results-item button[data-id="' +
					id +
					'"]'
			)
				.parent()
				.remove()
		}
	}
)

$(".filter-select__results-list").on(
	"click",
	".filter-select__results-item-delete",
	function() {
		let el = $(this)
		let id = el.attr("data-id")
		let p = el.closest(".filter-select")

		p.find(
			'.filter-select__selection-list .filter-select__selection-item input[value="' +
				id +
				'"]'
		)
			.prop("checked", false)
			.trigger("change")
		//el.closest(".filter-select__results-item").remove()
	}
)

$(".filter-select__search-input").on("input", function(e) {
	let v = $(this).val()
	let p = $(this).closest(".filter-select")
	p.find(".filter-select__selection-list .filter-select__selection-item").each(
		function() {
			let item = $(this)
			let name = item.find(".filter-select__selection-label").text()
			if (name.toLowerCase().indexOf(v.toLowerCase()) != -1) item.slideDown()
			else item.slideUp()
		}
	)
	e.preventDefault()
})

$(".filter-form__select").each(function() {
	var list = $(this)
		.select2({
			placeholder: $(this).attr("placeholder"),
			width: "100%",
			allowClear: true,
			containerCssClass: ".filter-form__select-container",
			dropdownCssClass: ".filter-form__select-popup",
			dropdownParent: $(this).closest(".filter-form__search"),
			closeOnSelect: false,
		})
		.on("select2:closing", function(e) {
			e.preventDefault()
		})
		.on("select2:closed", function(e) {
			list.select2("open")
		})
		.on("select2:open", function(e) {
			$(".select2-search input").blur()
			$("html, body").scrollTop(0)
		})

	list.select2("open")

	list.on("select2:select", function(e) {
		var data = e.params.data
		$(this)
			.closest(".filter-form__search")
			.next()
			.append(
				'<li class="filter-form__select-result" data-id="' +
					data.id +
					'"><button class="filter-form__select-result-delete"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.002 15"><path fill="#b7aca1" id="Path_' +
					data.id +
					'" d="M7.5 0A7.5 7.5 0 1 0 15 7.5 7.427 7.427 0 0 0 7.5 0zm3.8 9.7a1.217 1.217 0 0 1 0 1.6 1.217 1.217 0 0 1-1.6 0L7.5 9.2l-2.2 2.2a1.217 1.217 0 0 1-1.6 0 1.217 1.217 0 0 1 0-1.6l2.2-2.2-2.1-2.2a1.217 1.217 0 0 1 0-1.6 1.217 1.217 0 0 1 1.6 0L7.6 6l2.2-2.2a1.217 1.217 0 0 1 1.6 0 1.217 1.217 0 0 1 0 1.6L9.2 7.5z" data-name="Path ' +
					data.id +
					'"></path></svg><span>' +
					data.text +
					"</span></button></li>"
			)
	})

	list.on("select2:unselect", function(e) {
		var data = e.params.data
		$(this)
			.closest(".filter-form__search")
			.next()
			.find('.filter-form__select-result[data-id="' + data.id + '"]')
			.remove()
	})

	$(".filter__main").on("click", ".filter-form__select-result", function() {
		let id = $(this).attr("data-id")
		console.log(id)
		let block = $(this).closest(".filter-form__theme-subblock")
		block
			.find('select option[value="' + id + '"]')
			.prop("selected", false)
			.trigger("change")
		block.find("select").trigger("change")
		block
			.find(
				'.select2-container .select2-results__option[data-select2-id$="' +
					id +
					'"]'
			)
			.attr("aria-selected", false)
		$(this).remove()
	})
})

$(".filter-form").submit(function() {
	let form = $(this)
	useFilter(form)

	if ($(".filter").hasClass("active")) {
		$(".filter").removeClass("active")
		$("body").removeClass("no-scroll")
	}

	return false
})

$(".filter-form input, .filter-form select").change(function() {
	if ($(this).hasClass("filter-select__search-input")) return

	let form = $(this.form)
	useFilter(form)
})

$(".filter-form").on("reset", function() {
	setTimeout(function() {
		useFilter($(".filter-form"))
	}, 1)
})

function useFilter(form) {
	$(".catalog-page__list").prepend(
		'<li class="catalog__loader"><div class="catalog__loader-sign"></div></li>'
	)

	$.ajax({
		url: "/ajax.php?mid=1",
		type: "POST",
		data: form.serialize() + "&action=filter",
		dataType: "html",
		success: function(res) {
			$(".catalog-page__list, .catalog-page__list-empty").replaceWith(res)
		},
		fail: function(e) {
			console.log(e)
		},
	})
}

$(".popup-login__form").submit(function() {
	let form = $(this)
	$.ajax({
		url: "/ajax.php?mid=12",
		type: "POST",
		data: form.serialize(),
		dataType: "json",
		success: function(res) {
			if (res["success"]) {
				$(".popup-login").fadeOut(200)
				$(".header-panel__authorization").replaceWith(res["auth_block"])
			} else {
				swal("Ошибка: " + res["error"])
				if (res["activate_link"]) {
					swal(
						"Ошибка: " + res["error"],
						'<a href="' +
							res["activate_link"] +
							'" target="_blank">Выслать код активации повторно</a>'
					)
				}
			}
		},
		fail: function(e) {
			swal(
				"Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта"
			)
			console.log(e)
		},
	})

	return false
})

$(".cart-item__counter-btn, .method-main__counter button").click(function() {
	let el = $(this)
		.parent()
		.find("input")
	let n

	if (!el.val()) n = 0
	else n = parseInt(el.val())

	if ($(this).text() == "–") {
		if (n > 1) el.val(--n).trigger("change")
	} else el.val(++n).trigger("change")
})

$(".cart-item__counter-input").change(function() {
	cart.updateCount(this)
})

$("#cart-step-1 input[type=radio]").change(function() {
	if ($("#cart-step-1 input[type=radio]:checked").val() == 1) {
		$("#cart-step-2 .cart-form__tab-nav").hide()
		$("#cart-step-2 .cart-form__tab-nav input[type=radio]#nalp-0")
			.prop("checked", true)
			.trigger("change")

		$(".cart-form__data-jurlico").fadeIn()
		$(".cart-form__data-row--discount").fadeOut()
		$(".cart-form__data-jurlico input").attr("required", true)
		$(".cart-form__data-row--discount input").prop("disabled", true)
	} else {
		if ($("#cart-step-2").attr("data-can-nalp"))
			$("#cart-step-2 .cart-form__tab-nav").fadeIn()

		$(".cart-form__data-jurlico").fadeOut()
		$(".cart-form__data-row--discount").fadeIn()
		$(".cart-form__data-jurlico input").attr("required", false)
		$(".cart-form__data-row--discount input").prop("disabled", false)
	}

	$("#cart-step-2").slideDown()
})

$("#cart-step-2 .cart-form__tab-nav input[type=radio]").change(function() {
	let selector

	if (
		$("#cart-step-2 .cart-form__tab-nav input[type=radio]:checked").val() == 1
	) {
		if ($("#delivery-choose").attr("data-onlytk") == 1)
			selector = $("#delivery-choose li[data-not-tk != 1]")
		else selector = $("#delivery-choose li")

		selector.fadeIn()

		if ($("#cart-step-2").attr("data-can-nalp") == 1)
			selector = $("#delivery-choose li[data-nalp=0]")
		else selector = $("#delivery-choose li input[value!=0]").closest("li")

		selector.fadeOut()
		selector
			.find("input[type=radio]")
			.prop("checked", false)
			.trigger("change")
	} else {
		if ($("#delivery-choose").attr("data-onlytk") == 1)
			selector = $("#delivery-choose li[data-not-tk != 1]")
		else selector = $("#delivery-choose li")

		selector.fadeIn()

		selector = $("#delivery-choose li[data-postpay=0]")

		selector.fadeOut()
		selector
			.find("input[type=radio]")
			.prop("checked", false)
			.trigger("change")
	}
})

$("#delivery-choose input[type=radio]").change(function() {
	if ($("#delivery-choose input[type=radio]:checked").length) {
		$("#cart-step-3").slideDown()
	} else {
		$("#cart-step-3").slideUp()
	}

	if ($("#delivery-choose input[type=radio]:checked").val() != "0") {
		$(".cart-form__data-row--adress").slideDown()
		$(".cart-form__data-row--adress input[type=text]").attr("required", true)
	} else {
		$(".cart-form__data-row--adress").slideUp()
		$(".cart-form__data-row--adress input[type=text]").attr("required", false)
	}

	cart.calcTotalSum()
})

$("input[name='chk_is_ip']").change(function() {
	if ($("input[name='chk_is_ip']:checked").val() == "1") {
		// ИП
		$("#str_kpp")
			.closest(".cart-form__data-input-wrapper")
			.hide()
		$("input[name='str_kpp']").attr("required", false)
		$("input[name='str_kpp']").val("-")
	} else {
		// Юр лицо
		if ($("input[name='str_kpp']").val() == "-")
			$("input[name='str_kpp']").val("")
		$("#str_kpp")
			.closest(".cart-form__data-input-wrapper")
			.show()
		$("input[name='str_kpp']").attr("required", true)
	}
})

function parseINN() {
	this.value = this.value.replace(/\D/g, "")

	if (this.value.length >= 10) {
		cart.findOrg(this.value, $("input[name='chk_is_ip']:checked").val())
	}
}

$("input[name='str_inn']").bind("input", parseINN)

function calcCartSums() {}

// возвращает cookie если есть или undefined
function getcookie(name) {
	var matches = document.cookie.match(
		new RegExp(
			"(?:^|; )" +
				name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
				"=([^;]*)"
		)
	)
	return matches ? decodeURIComponent(matches[1]) : undefined
}
function setcookie(name, value, expires, path, domain, secure) {
	// Send a cookie
	//
	// +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)

	expires instanceof Date
		? (expires = expires.toGMTString())
		: typeof expires == "number" &&
		  (expires = new Date(+new Date() + expires * 1e3).toGMTString())
	var r = [name + "=" + escape(value)],
		s,
		i
	for (i in (s = { expires: expires, path: path, domain: domain })) {
		s[i] && r.push(i + "=" + s[i])
	}
	return secure && r.push("secure"), (document.cookie = r.join(";")), true
}

if (!getcookie("cookieAccepted")) {
	$(".cookie").addClass("active")
}

$(".cookie__btn").on("click", function() {
	setcookie("cookieAccepted", 1, 60 * 60 * 24 * 365, "/")
	$(".cookie").removeClass("active")
})

function showPopupImg() {
	if (!getcookie("popup-img_showed")) {
		$(".popup-img").slideDown("300")
		$("body").addClass("no-scroll")
		setcookie("popup-img_showed", 1, 60 * 60 * 4, "/")
	}

	$(".popup-img__close").on("click", function() {
		$(this)
			.parents(".popup-img")
			.slideUp(300)
		$("body").removeClass("no-scroll")
	})
	$(".popup-img").on("click", function(e) {
		var callbackPopup = $(".popup-img__main")
		if (
			!callbackPopup.is(e.target) &&
			callbackPopup.has(e.target).length === 0
		) {
			$(this).slideUp(300)
			$("body").removeClass("no-scroll")
		}
	})
}

$(document).ready(function() {
	$('a[href^="#"]')
		.not(".popup-link")
		.click(function() {
			let elementClick = $(this)
				.attr("href")
				.replace(/#/, "")
			if (elementClick && $("a[name=" + elementClick + "]").length) {
				let destination =
					$("a[name=" + elementClick + "]").offset().top -
					$(".header-panel").height() -
					$(".header-menu").height() -
					($(".simple-wrapper__nav").length
						? $(".simple-wrapper__nav").height()
						: 0) -
					12
				$("html, body").animate({ scrollTop: destination }, 1100)
				return false
			}
		})

	if (window.location.pathname == "/cart/" && $(".cart-main").length) {
		cart.getCartInfo()
	}

	//showPopupImg()
})

$("#search_text").keyup(function(e) {
	live_search()
})

$("#search_text").focus(function() {
	show_search()
})

function show_search() {
	$(".popup-search").show()
	$(window).on("click", test_hide_search)
}

function test_hide_search(e) {
	var el = $(e.target)
	if (
		!el.closest(".popup-search").length &&
		!el.closest(".header-panel__search").length
	)
		hide_search()
}

function hide_search() {
	$(".popup-search").hide()
	$(window).off("click", test_hide_search)
}

var currentRequest = null

function live_search() {
	var text = $("#search_text").val()

	if (text.length > 2) {
		$("#search_res").addClass("loading")
		$("#search_res .text").hide()

		currentRequest = $.ajax({
			url: "/ajax.php?mid=6",
			type: "POST",
			data: {
				text: text,
			},
			dataType: "json",
			beforeSend: function() {
				if (currentRequest != null) {
					currentRequest.abort()
				}
			},
			success: function(res) {
				var cont = $(".popup-search__list")
				var row, r

				cont.html("")
				if (res["result"].length) {
					for (var i = 0; i < res["result"].length; i++) {
						r = res["result"][i]
						row = $(
							'<li class="popup-search__item"><a class="popup-search__item-link" href="/catalog/' +
								r["trans"] +
								'/"></a><div class="popup-search__item-container"><img class="popup-search__item-image" src="' +
								r["img"] +
								'" alt=""><div class="popup-search__item-title">' +
								r["name"] +
								"</div></div></li>"
						)
						//console.log(r['id']);
						cont.append(row)
					}
					$(".popup-search__title").text("Всего найдено: " + res["count"])

					if (res["count"] > res["result"].length) {
						$("#search_res .all").show()
						$("#search_res .all a").attr("href", "/search/?search_text=" + text)
					} else {
						$("#search_res .all").hide()
					}
				} else {
					$(".popup-search__title").text("Ничего не найдено")
					$("#search_res .all").hide()
				}

				$("#search_res").removeClass("loading")
			},
			error: function(err) {},
		})
	} else {
		$("#search_res .text").show()
		$(".popup-search__title").text("Введите хотя бы 3 символа")
	}
}

$(".news__item-more").click(function() {
	$(this).toggleClass("active")
	$(this)
		.siblings(".news__item-text")
		.children(".news__item-text-hidden")
		.slideToggle()
})

$(".personal-page__content")
	.children(".personal-page__content-tab")
	.not(":first")
	.hide()

/*$(".personal-page__nav-btn")
	.click(function() {
		$(".personal-page__nav-btn")
			.removeClass("active")
			.eq($(this).index())
			.addClass("active")
		$(".personal-page__content-tab")
			.slideUp(400)
			.eq($(this).index())
			.delay(400)
			.slideDown(400)
	})
	.eq(0)
	.addClass("active")*/

$("input[name=str_adress]").suggestions({
	token: "42d084f2519f09814fb5fdad8bd401c2c170984a",
	type: "ADDRESS",
	onSelect: function(sug) {
		$("#str_index").val(sug.data.postal_code)
		cart.validAdress(sug.value)
		console.log(sug)
	},
})
$("input[name=str_adress]").blur(function() {
	cart.validAdress($(this).val())
})

$("#chk_calendar").change(function() {
	if ($(this).prop("checked")) {
		$(".reg-prod__input[name=str_adress]").attr("required", true)
		$(".reg-prod__radio-input").attr("required", true)
	} else {
		$(".reg-prod__input[name=str_adress]").attr("required", false)
		$(".reg-prod__radio-input").attr("required", false)
	}
})

$(".feedback__mailing form").submit(async function(e) {
	e.preventDefault()

	let form = $(this)
	let email = form.find(".form__input").val()

	let recpatchaSelector = document.querySelector('meta[name="captcha"]')
	let recaptchaToken = ""
	if (recpatchaSelector) {
		let recpatchaKey = recpatchaSelector.content
		recaptchaToken = await grecaptcha.execute(recpatchaKey, {
			action: "submit",
		})
	}

	$.ajax({
		url: "/ajax.php?mid=23",
		type: "POST",
		data: {
			email: email,
		},
		dataType: "json",
		success: function(res) {
			if (res.success) {
				form.replaceWith(
					'<div class="success">Вы успешно подписались на рассылку</div>'
				)
			} else {
				swal("Ошибка", res.text)
			}
		},
		error: function(err) {},
	})

	return false
})

$(".popup-typical--inform form").submit(function() {
	let form = $(this)
	let item_id = form.find(".cart-item-id").val()
	let contact = form.find(".popup-typical__form-input[name='str_email']").val()
	let phone = form.find(".popup-typical__form-input[name='str_phone']").val()

	$.ajax({
		url: "/ajax.php?mid=1",
		type: "POST",
		data: {
			action: "remind",
			item_id: item_id,
			str_contact: contact,
			str_contact2: phone,
		},
		dataType: "json",
		success: function(res) {
			if (res["success"]) {
				form.find(".popup-typical__form-container").hide()

				form
					.find(".popup-typical__form-error")
					.text("")
					.fadeOut()
				form
					.find(".popup-typical__form-success")
					.text("Спасибо! Мы известим Вас, когда товар будет в наличии")
					.fadeIn()

				form.find('button.popup-typical__btn[type="submit"]').hide()
			} else {
				form
					.find(".popup-typical__form-error")
					.text(res["error"])
					.fadeIn()
				form
					.find(".popup-typical__form-success")
					.text("")
					.fadeOut()
			}
		},
		error: function(err) {},
	})

	return false
})

$(".reg-prod__sert-help").click(function(e) {
	e.preventDefault()
	$(".reg-prod__sert-help-text").slideToggle()
})

$("form.faq__form .form__submit").click(async function(e) {
	e.preventDefault()

	let form = $("form.faq__form")

	let text = form.find(".faq__textarea")
	let email = form.find(".form__input")
	let chkPersonalData = form.find("[name='chk_personal_data']")

	console.log(chkPersonalData)

	const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu
	var validated = true

	if (text.val().length <= 0) {
		text.addClass("err")
		validated = false
	} else {
		text.removeClass("err")
	}

	if (EMAIL_REGEXP.test(email.val())) {
		email.removeClass("err")
	} else {
		email.addClass("err")
		validated = false
	}

	if (chkPersonalData.prop("checked")) {
		chkPersonalData.next().removeClass("err")
	} else {
		chkPersonalData.next().addClass("err")
		validated = false
	}

	if (validated) {
		$.ajax({
			url: "/ajax.php?mid=34&action=send_question",
			type: "POST",
			data: {
				str_email: email.val(),
				txt_text: text.val(),
			},
			dataType: "json",
			success: function(res) {
				if (res.success) {
					form.replaceWith(
						'<div class="faq__success">Спасибо! Ваш вопрос получен. Мы ответим на Вашу почту в рабочее время.</div>'
					)
				} else {
					swal("Ошибка", res.text)
				}
			},
			error: function(err) {},
		})
	}
})

$(".simple-main__requirements-btn").click(function(e) {
	$(".simple-main__requirements-popup").fadeToggle()
})

$(document).click(function(e) {
	var callbackPopup = $(".simple-main__requirements-btn")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(".simple-main__requirements-popup").fadeOut(300)
	}
})

function parsePhoneNumber() {
	var num = this.value
			.replace(/^(8|7|\+7\(7|\+7)/, "")
			.replace(/\D/g, "")
			.split(/(?=.)/),
		i = num.length
	if (0 <= i) num.unshift("+7")
	if (1 <= i) num.splice(1, 0, "(")
	if (4 <= i) num.splice(5, 0, ")")
	if (7 <= i) num.splice(9, 0, "-")
	if (9 <= i) num.splice(12, 0, "-")
	if (11 <= i) num.splice(15, num.length - 15), showPhoneFormatWarning()
	this.value = num.join("")
}
function checkPhoneNumber() {
	if (this.value.length < 16) (this.value = ""), showPhoneFormatWarning()
	else hidePhoneFormatWarning()
}
function showPhoneFormatWarning() {
	$("#str_phone_comment").html(
		"Вы пытаетесь указать телефон, не соответствующий формату. Если Ваш номер не в России, <a href=\"#\" onclick=\"$('#str_phone_mask').prop('checked', true).trigger('change'); return false;\">отметьте это галочкой</a> и повторите ввод."
	)
}
function hidePhoneFormatWarning() {
	$("#str_phone_comment").html("")
}

$.fn.formatPnoneNumber = function() {
	return this.each(function() {
		$(this).bind("input", parsePhoneNumber)
		$(this).bind("blur", checkPhoneNumber)
	})
}
$.fn.unformatPnoneNumber = function() {
	return this.each(function() {
		$(this).unbind("input", parsePhoneNumber)
		$(this).unbind("blur", checkPhoneNumber)
		hidePhoneFormatWarning()
	})
}

$("#str_phone").formatPnoneNumber()
$("#str_phone_mask").change(function() {
	if ($(this).prop("checked")) $("#str_phone").unformatPnoneNumber()
	else $("#str_phone").formatPnoneNumber()
})

$(".cart-form").submit(function() {
	console.log("cart-form")

	if ($("#cart-step-1 input[type=radio]:checked").val() == 0) {
		return cart.checkBeforeSubmit()
	}

	var checkRes = true

	// Проверка ИНН

	var inn = $("input[name='str_inn']").val()
	console.log(inn)
	if ($("input[name='chk_is_ip']:checked").val() == "1") {
		if (inn.length != 12) {
			checkRes = false
			$("#str_inn_comment").html("ИНН должно состоять из 12 цифр")
		}
	} else {
		if (inn.length != 10) {
			checkRes = false

			$("#str_inn_comment").html("ИНН должно состоять из 10 цифр")
		}
	}

	if (checkRes) {
		$("#str_inn_comment").html("")

		return cart.checkBeforeSubmit()
	} else {
		console.log("FALSE")
		return false
	}
})

if (window.location.hash == "#auth") {
	$(".popup-login").show()
}

$(".popup__close, .popup__cancel").click(function(e) {
	$("body").removeClass("no-scroll")
	$(this)
		.closest(".popup")
		.removeClass("active")
})

$(".popup").click(function(e) {
	var callbackPopup = $(".popup__container")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active")
		$("body").removeClass("no-scroll")
	}
})

$(".callback__button").click(function() {
	addPhoneCodes()
	$(".popup").addClass("active")
	$("body").addClass("no-scroll")
})

//=====================================================
// Заказ обратного звонка

$(function() {
	"use strict"

	$("form.popup-callback__content").submit(function(event) {
		event.preventDefault()

		let name = $("form.popup-callback__content input[name='name']").val()
		let phone = $("form.popup-callback__content input[name='telephone']").val()

		if (name.length < 2) {
			$("form.popup-callback__content .form__mistakes p")
				.text("Пожалуйста, укажите имя!")
				.show()
			return
		}

		if (phone.length < 10) {
			$("form.popup-callback__content .form__mistakes p")
				.text("Пожалуйста, укажите корректный телефон!")
				.show()
			return
		}

		$.ajax({
			url: "/action/callback.php",
			type: "POST",
			data: { name: name, phone: phone },
			dataType: "json",
			success: function(res) {
				if (res.status != undefined) {
					if (res.status == 1) {
						$("form.popup-callback__content .form__mistakes p")
							.text("")
							.hide()
						$(".popup-callback__step--1").removeClass("active")
						$(".popup-callback__step--2").addClass("active")
					} else {
						if (res.message != undefined)
							$("form.popup-callback__content .form__mistakes p")
								.text("Возникла ошибка! " + res.message)
								.show()
						else
							$("form.popup-callback__content .form__mistakes p")
								.text(
									"Возникла ошибка! Пожалуйста, проверьте данные и повторите операцию!"
								)
								.show()
					}
				} else {
					$("form.popup-callback__content .form__mistakes p")
						.text("Возникла ошибка! Пожалуйста, повторите операцию!")
						.show()
				}
			},
			fail: function(e) {
				console.log(e)
			},
		})
	})
})

function checkCaptchaAndSubmit(form) {
	let recpatchaSelector = document.querySelector('meta[name="captcha"]')
	if (recpatchaSelector) {
		grecaptcha.ready(function() {
			grecaptcha
				.execute(recpatchaSelector.content, { action: "submit" })
				.then(function(token) {
					form.append(
						'<input type="hidden" name="token" value="' + token + '">'
					)
					form.submit()
				})
		})
	} else {
		form.submit()
	}
}

//add working time badge
/*const badge = document.getElementById(badge);
	badge.innerText = 'сейчас работаем'

	console.log(badge)

	const date = new Date();
	const day = date.getDay();
	const hour = date.getHours();
	const minutes = date.getMinutes();
	if (day === 5 || day === 6) {
		badge.innerText = 'закрыты';
	} else if ((day === 4) & (hour < 11) & (hour > 19)){
		badge.innerText = 'закрыты';
	} else if ((hour < 9 & minutes < 30) & (hour > 17 & minutes > 30)){
		badge.innerText = 'закрыты';
	} else {
		badge.innerText = 'сейчас работаем';
	}

	console.log(date)*/

$(document).ready(function() {
	const date = new Date()
	const day = date.getDay()
	const hour = date.getHours()
	const minutes = date.getMinutes()

	$(".badge").text("Принимаем онлайн-заказы")
	$(".badge").css("color", "green")

	// Убрано на время работы онлайн (на лето)
	// if (day === 6 || day === 0) {
	// 	$(".badge").text("закрыты")
	// } else if (day === 5) {
	// 	if (hour < 11 || hour > 19) {
	// 		$(".badge").text("закрыты")
	// 	} else {
	// 		$(".badge").text("сейчас работаем")
	// 	}
	// } else {
	// 	if ((hour < 9 && minutes < 30) || (hour > 17 && minutes > 30)) {
	// 		$(".badge").text("закрыты")
	// 	} else {
	// 		$(".badge").text("сейчас работаем")
	// 		$(".badge").addClass("active")
	// 	}
	// }
	//-console.log(day, hour, minutes)
})
$(document).on("click", ".reg-prod__submit.reg-prod__form--sert", function(e) {
	e.preventDefault()
	var form = $(".reg-prod__form--sert")

	var cardField = form.find("[name='str_card']")
	if (cardField.val().length > 0) {
		prod.sendSert(form)
	} else {
		cardField.addClass("err")
	}
})
$(".reg-prod__submit.reg-prod__form--sert").click(function(e) {
	e.preventDefault()
	var form = $(".reg-prod__form--sert")

	// Проверяем поля формы на валидность
	var fields = new Map()
	fields.set("card", form.find("[name='str_card']"))
	var validatedCount = []

	fields.forEach(function(fieldValue, fieldName) {
		let validated = true

		// Проверка на существование значения
		const value = fieldValue.val()
		if (value === undefined || value.length <= 0) {
			validated = false
		}

		// Обновление классов в зависимости от результата валидации
		if (validated) {
			fieldValue.removeClass("err")
			validatedCount.push(true)
		} else {
			fieldValue.addClass("err")
		}
	})

	if (validatedCount.length === fields.size) {
		sendSert(form)
	}
})
$(document).on("submit", ".reg-prod__themes form", function(e) {
	e.preventDefault()
	var form = $(this)
	prod.sendTopics(form)
})

document.addEventListener("DOMContentLoaded", function() {
	const chkCalendar = document.getElementById("chk_calendar")
	const calendarBlock = document.getElementById("calendar_block")
	const calendarBlock1 = document.getElementById("calendar_block1")

	function toggleCalendarBlocks() {
		if (chkCalendar.checked) {
			calendarBlock.style.display = "block"
			calendarBlock1.style.display = "block"
		} else {
			calendarBlock.style.display = "none"
			calendarBlock1.style.display = "none"
		}
	}

	toggleCalendarBlocks()

	chkCalendar.addEventListener("change", toggleCalendarBlocks)
})
